var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"strategio-loading-main"},[_c('p',[_c('v-progress-circular',{staticStyle:{"color":"#00C3D7"},attrs:{"indeterminate":"","size":"50"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"strategio-loading-main-message"},[_vm._v("\n      Un momento por favor\n    ")])],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29dcc76a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom-loading.vue
// module id = null
// module chunks = 